import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import Event from 'models/event';
import Venue from 'models/venue';

const propTypes = {
  event: PropTypes.instanceOf(Event).isRequired,
  venue: PropTypes.instanceOf(Venue),
};

const defaultProps = {
  venue: null,
};

const EventContent = ({ event, venue }) => (
  <div className="display-table">
    <div className="display-table-cell">
      <div className="background-color-dark-slate text-color-white text-center padding-10 uppercase text-size-xs-16 text-size-sm-14">
        <div>{event.startTime.format('MMM')}</div>
        <div>{event.startTime.format('D')}</div>
      </div>
    </div>
    <div className="display-table-cell padding-left-15 vertical-align-top">
      <div className="text-size-20 text-weight-book margin-bottom-10">
        {event.name}
      </div>
      <div className="text-size-14 text-weight-bold">
        at {get(venue, 'name', '')} @ {event.startTime.format('h:mmA')}
      </div>
    </div>
  </div>
);

EventContent.propTypes = propTypes;
EventContent.defaultProps = defaultProps;
export default EventContent;
